import { getAuthToken } from "./api";
import { useCallback } from 'react';
import store from 'store';
import { post } from "utils/api";
import useSWR from 'swr';
import { snakeCase } from 'lodash';
import { filterUTMParams, getParameters, updateUtmMedium } from "members/helper";

const fetchToken = async ({ id, secret }) => {
  store.remove('auth_token');
  const newToken = await getAuthToken({ id, secret });
  store.set('auth_token', newToken);
};

export const useGetCurrentMember = () => useSWR('/v3/me');

export const useCurrentMemberTrackingId = () => {
  const { data } = useGetCurrentMember();
  if (data?.data?.data?.attributes) {
    const { "tracking-identifier": trackingIdentifier } = data?.data?.data?.attributes;
    return trackingIdentifier;
  }
  return null;
};

export const useCreateNewAccount = () => {
  return useCallback(
    async (attributes = undefined) => {
      let res = null;
      let formattedValues = null;
      const updatedQuery = getParameters(window.location.search);
      if (updatedQuery && Object.keys(updatedQuery).find((o) => o.includes('utm'))) {
        const { step, ...refinedQuery } = updatedQuery;
        formattedValues = Object.keys(refinedQuery).reduce((acc, el) => {
          const formattedKey = snakeCase(el);
          return { ...acc, [formattedKey]: updatedQuery[el] };
        }, {});
        if (step === '2a') {
          formattedValues['utm_medium'] = 'hero-button';
        }
      }

      let updatedUTMParams = filterUTMParams(window?.location?.search, '?');
      if (updatedQuery?.step === '2a') {
        updatedUTMParams = updateUtmMedium(filterUTMParams(window?.location?.search, '?'))
      }

      if (attributes) res = await post(`/v3/child_journal_members${updatedUTMParams}`, { data: { attributes: { ...attributes, ...formattedValues } } });
      else res = await post(`/v3/child_journal_members${updatedUTMParams}`, formattedValues);
      if (res.status === 200 || res.status === 201) {
        const { id, secret } = res.data.entities.restore_token[res.data.initial.data.id]

        const token = await fetchToken({ id, secret });
        return token;
      }
      return null;
    },
    []
  );
};

export const useCreateNewV3Account = () => {
  return useCallback(
    async (attributes = undefined) => {
      let res = null;
      res = await post('/v3/accounts', attributes);
      if (res.status === 200 || res.status === 201) {
        const { id, secret } = res.data.entities.restore_token[res.data.initial.data.id]

        const token = await fetchToken({ id, secret });
        return token;
      }
      return null;
    },
    []
  );
};

export const useLogin = () => {
  return async (attributes) => {
    const loginResponse = await post(
      `/v3/login`,
      { ...attributes }
    );
    const { id, secret } = loginResponse.data?.initial.data.attributes;
    await fetchToken({ id, secret });
  };
};